import { PaymentMethod } from '@/domain/stripe/customer/sub-domains/paymentMethod/model/PaymentMethod'

export class CustomerPaymentMethods {
  constructor(
    public readonly customerId: string,
    public readonly paymentMethods: PaymentMethod[],
  ) {
  }
}
